var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2873_701619)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 30,
    r: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7346 33.9327L30.268 36.3993C29.748 36.9193 28.9213 36.9193 28.388 36.4127C28.2413 36.266 28.0946 36.1327 27.948 35.986C26.5746 34.5993 25.3346 33.146 24.228 31.626C23.1346 30.106 22.2546 28.586 21.6146 27.0793C20.988 25.5594 20.668 24.106 20.668 22.7193C20.668 21.8127 20.828 20.946 21.148 20.146C21.468 19.3327 21.9746 18.586 22.6813 17.9193C23.5346 17.0793 24.468 16.666 25.4546 16.666C25.828 16.666 26.2013 16.746 26.5346 16.906C26.8813 17.066 27.188 17.306 27.428 17.6527L30.5213 22.0127C30.7613 22.346 30.9346 22.6527 31.0546 22.946C31.1746 23.226 31.2413 23.506 31.2413 23.7593C31.2413 24.0793 31.148 24.3993 30.9613 24.706C30.788 25.0127 30.5346 25.3327 30.2146 25.6527L29.2013 26.706C29.0546 26.8527 28.988 27.026 28.988 27.2393C28.988 27.346 29.0013 27.4393 29.028 27.546C29.068 27.6527 29.108 27.7327 29.1346 27.8127C29.3746 28.2527 29.788 28.826 30.3746 29.5194C30.9746 30.2127 31.6146 30.9193 32.308 31.626C32.4413 31.7593 32.588 31.8927 32.7213 32.026C33.2546 32.546 33.268 33.3993 32.7346 33.9327Z",
    fill: "#037CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2941 38.4407C47.2941 38.814 47.2274 39.2007 47.0941 39.574C47.0541 39.6807 47.0141 39.7874 46.9608 39.894C46.7341 40.374 46.4408 40.8274 46.0541 41.254C45.4008 41.974 44.6808 42.494 43.8674 42.8274C43.8541 42.8274 43.8408 42.8407 43.8274 42.8407C43.0408 43.1607 42.1874 43.334 41.2674 43.334C39.9074 43.334 38.4541 43.014 36.9208 42.3607C35.3874 41.7074 33.8541 40.8274 32.3341 39.7207C31.8141 39.334 31.2941 38.9474 30.8008 38.534L35.1608 34.174C35.5341 34.454 35.8674 34.6674 36.1474 34.814C36.2141 34.8407 36.2941 34.8807 36.3874 34.9207C36.4941 34.9607 36.6008 34.974 36.7208 34.974C36.9474 34.974 37.1208 34.894 37.2674 34.7474L38.2808 33.7474C38.6141 33.414 38.9341 33.1607 39.2408 33.0007C39.5474 32.814 39.8541 32.7207 40.1874 32.7207C40.4408 32.7207 40.7074 32.774 41.0008 32.894C41.2941 33.014 41.6008 33.1874 41.9341 33.414L46.3474 36.5474C46.6941 36.7874 46.9341 37.0674 47.0808 37.4007C47.2141 37.734 47.2941 38.0674 47.2941 38.4407Z",
    fill: "#037CCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2873_701619",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2873_701619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2873_701619",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFone);
export default __webpack_public_path__ + "static/media/fone.7b467b1cdfec7567345802c353518223.svg";
export { ForwardRef as ReactComponent };